import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-table-novedad-traslados',
  templateUrl: './table-novedad-traslados.component.html',
  styleUrls: ['./table-novedad-traslados.component.css'],
})
export class TableNovedadTrasladosComponent implements OnChanges {
  dataSource = new MatTableDataSource<any>([]);
  @Input() Tarifa: string = '';
  @Input() EstructuraTarifaria: string = '';
  @Input() readonly = false;

  get tarifaDisplay(): string {
    if (this.Tarifa) {
      return this.normalizeText(this.Tarifa);
    }
    const row =
      this.data && this.data.length > 0
        ? this.data[0]
        : this.dataSource &&
            this.dataSource.data &&
            this.dataSource.data.length > 0
          ? this.dataSource.data[0]
          : null;
    if (!row) return '';
    const val =
      row.Tarifa ??
      row.tarifa ??
      row.TARIFA ??
      row.NombreTarifa ??
      row.nombreTarifa ??
      row.TarifaContrato ??
      row.tarifaContrato ??
      null;
    return this.normalizeText(val);
  }

  get estructuraTarifariaDisplay(): string {
    if (this.EstructuraTarifaria) {
      return this.normalizeText(this.EstructuraTarifaria);
    }
    const row =
      this.data && this.data.length > 0
        ? this.data[0]
        : this.dataSource &&
            this.dataSource.data &&
            this.dataSource.data.length > 0
          ? this.dataSource.data[0]
          : null;
    if (!row) return '';
    const val =
      row.EstructuraTarifaria ??
      row.estructuraTarifaria ??
      row.estructura_tarifaria ??
      row.EstructuraTarifa ??
      row.estructuraTarifa ??
      null;
    return this.normalizeText(val);
  }

  private normalizeText(v: any): string {
    if (v === null || v === undefined) return '';
    const s = String(v);
    if (s.trim().toLowerCase() === 'undefined') return '';
    return s;
  }
  @Output() selectionChange = new EventEmitter<boolean>();
  @Output() rowsSelected = new EventEmitter<any[]>();
  @Input() preselectedRows: any[] = [];
  @Input() data: any[] = [];
  displayedColumns: string[] = [
    'select',
    'no',
    'identificacion',
    'nombreUsuario',
    'parentesco',
    'edad',
    'genero',
    'fechaNacimiento',
    'fechaAntiguedad',
    'anexo',
    'valorTarifaAnexo',
    'valorTarifaPrograma',
    'totalTarifa',
    'campaniaVigente',
    'congelamiento',
  ];

  footerColumns = [
    'select',
    'no',
    'identificacion',
    'nombreUsuario',
    'parentesco',
    'edad',
    'genero',
    'fechaNacimiento',
    'fechaAntiguedad',
    'anexo',
    'footerTotals',
    'campaniaVigente',
    'congelamiento',
  ];

  selection = new SelectionModel<any>(true, []);

  ngOnInit() {
    this.selection.changed.subscribe(() => {
      this.selectionChange.emit(this.selection.selected.length > 0);
      this.rowsSelected.emit(this.selection.selected);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.dataSource = new MatTableDataSource(this.data ?? []);
      this.selection.clear();
    }
    if (changes['preselectedRows']) {
      if (
        this.preselectedRows?.length > 0 &&
        this.dataSource.data?.length > 0
      ) {
        this.restorePreselectedRows();
      }
    }
  }

  restorePreselectedRows() {
    this.preselectedRows.forEach((savedRow) => {
      const match = this.dataSource.data.find(
        (x) => x.identificacion === savedRow.identificacion,
      );
      if (match) {
        this.selection.select(match);
      }
    });
  }

  toggleAllRows() {
    if (this.readonly) return;
    
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.selection.select(...this.dataSource.data);
    }
  }

  isAllSelected() {
    return this.selection.selected.length === this.dataSource.data.length;
  }

  isSomeSelected() {
    return this.selection.selected.length > 0 && !this.isAllSelected();
  }

  get totalCuotaConIva(): number {
    return this.dataSource.data.reduce(
      (sum, row) => sum + this.leerTotalTarifaFila(row),
      0,
    );
  }

  private leerTotalTarifaFila(row: Record<string, unknown>): number {
    const raw =
      row['totalTarifa'] ?? row['TotalTarifa'] ?? row['total_tarifa'] ?? 0;
    const n = Number(raw);
    return Number.isFinite(n) ? n : 0;
  }

  clearSelection() {
    this.selection.clear();
    this.selectionChange.emit(false);
    this.rowsSelected.emit([]);
  }
}
